define(()=> {
    function isPromise(value) {
        return value && typeof value.then === 'function';
    }

    function isMessagePlusInterpolation(value) {
        return value && typeof value.key === 'string';
    }

    return ['$scope', '$filter', '$translate', '$q', 'model', ($scope, $filter, $translate, $q, model)=> {
        function translate(val) {
            if (isPromise(val)) {
                return val;
            }
            if (isMessagePlusInterpolation(val)) {
                return $translate(val.key, val.args || {}, undefined, val.key);
            }
            return $q.when(typeof val === 'string' && val.length ?
                $translate(val, undefined, undefined, val) :
                val);
        }

        function writeToScope(prop) {
            return (msg)=> {
                $scope[prop] = msg;
            };
        }

        $scope.iconClass = model.iconClass;
        $scope.showCancelBtn = model.showCancelBtn;
        $scope.cancelBtnLabel = model.cancelBtnLabel;

        translate(model.title).then(writeToScope('title'));
        translate(model.message).then(writeToScope('message'));
        translate(model.description).then(writeToScope('description'));

        if (model.action) {
            $scope.action = {
                btnClass: model.action.btnClass,
                label: model.action.label || $filter('translate')('platform.modal.ModalCtrl.OK'),
            };
        }
    }];
});



// WEBPACK FOOTER //
// ./app/customer/js/src/edge/platform/widgets/modal/ModalCtrl.js